import(/* webpackMode: "eager", webpackExports: ["CtaBanner"] */ "/vercel/path0/src/app/(general)/free-tools/business/marketing-budget-allocator/CtaBanner.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MarketingBudgetContent"] */ "/vercel/path0/src/app/(general)/free-tools/business/marketing-budget-allocator/MarketingBudgetContent.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MarketingBudgetTool"] */ "/vercel/path0/src/app/(general)/free-tools/business/marketing-budget-allocator/MarketingBudgetTool.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Faq"] */ "/vercel/path0/src/components/faq/faq.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/vercel/path0/src/components/header/header.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrustedBy"] */ "/vercel/path0/src/components/trustedBy/trustedBy.comp.tsx");
